import * as React from 'react';

import TextEditorWithContext, { Props } from '@web/richText/TextEditorWithContext';

const TextEditor: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return <TextEditorWithContext {...props} />;
};

export default TextEditor;
